<div [class.show]="serviceConfigId" class="backdrop" (click)="onCloseForm()"></div>

<div [class.show]="serviceConfigId" class="sidepanel">
  <div class="header">
    <span>Update data mapping</span>
    <nx-icon [name]="'close'" size="s" (click)="onCloseForm()"></nx-icon>
  </div>

  <div class="body">
    @if (serviceConfigForm && !isServiceConfigLoading && responseError?.errorType !== 'loadServiceConfig') {
    <form [formGroup]="serviceConfigForm">
      <nx-formfield appearance="outline" label="PagerDuty Service ID" floatLabel="always">
        <input nxInput formControlName="pagerDutyServiceId" readonly />
      </nx-formfield>
      <nx-formfield appearance="outline" label="PagerDuty Service Name" floatLabel="always">
        <input nxInput formControlName="pagerDutyServiceName" readonly />
      </nx-formfield>
      <nx-formfield appearance="outline" label="Related Service Offering" floatLabel="always">
        <input nxInput formControlName="serviceIntegrationManagementServiceOffering"
          [readonly]="!(permissionService.can_write_service_config$ | async)" />
      </nx-formfield>
      <nx-formfield appearance="outline" label="Related Business Service" floatLabel="always">
        <input nxInput formControlName="serviceIntegrationManagementBusinessService"
          [readonly]="!(permissionService.can_write_service_config$ | async)" />
      </nx-formfield>
      <nx-formfield appearance="outline" label="Assignment group" floatLabel="always">
        <input nxInput formControlName="serviceIntegrationManagementAssignmentGroup"
          [readonly]="!(permissionService.can_write_service_config$ | async)" />
      </nx-formfield>
      <nx-formfield appearance="outline" label="Users Distribution list" floatLabel="always">
        <input nxInput #addEmailDistributionInput
          (keydown.enter)="$event.preventDefault(); addEmailToDistributionList(addEmailDistributionInput.value, addEmailDistributionInput)"
          (keydown.space)="$event.preventDefault(); addEmailToDistributionList(addEmailDistributionInput.value, addEmailDistributionInput)"
          (keydown.,)="$event.preventDefault(); addEmailToDistributionList(addEmailDistributionInput.value, addEmailDistributionInput)"
          [readonly]="!(permissionService.can_write_service_config$ | async)"
          placeholder="Type email and press Enter, Space, or Comma to add" />
      </nx-formfield>
      <nx-taglist [(tags)]="emailDistributionList"
        [class.read-only]="!(permissionService.can_write_service_config$ | async)"></nx-taglist>
      <nx-formfield appearance="outline" label="Jira Project" floatLabel="always">
        <input nxInput formControlName="jiraProjectId"
          [readonly]="!(permissionService.can_write_service_config$ | async)" />
      </nx-formfield>
      <nx-formfield appearance="outline" label="Contact Email" floatLabel="always">
        <input nxInput type="email" formControlName="contactEmail"
          [readonly]="!(permissionService.can_write_service_config$ | async)" />
      </nx-formfield>
      <nx-formfield appearance="outline" label="Pager Duty team ID" floatLabel="always">
        <input nxInput formControlName="pagerDutyTeamId"
          [readonly]="!(permissionService.can_write_service_config$ | async)" />
      </nx-formfield>
      <nx-formfield appearance="outline" label="Collaborative platform channel ID" floatLabel="always">
        <input nxInput formControlName="collaborativePlatformChannelId"
          [readonly]="!(permissionService.can_write_service_config$ | async)" />
      </nx-formfield>
      <nx-formfield appearance="outline" label="Collaborative platform group ID" floatLabel="always">
        <input nxInput formControlName="collaborativePlatformGroupId"
          [readonly]="!(permissionService.can_write_service_config$ | async)" />
      </nx-formfield>

      <div class="audit-section">
        <span class="audit-section-title">Audit information</span>
        <div class="audit-fields">
          <div class="audit-field">
            <span class="audit-label">Created by</span>
            <span class="audit-value">{{ serviceConfigForm.get('createdby')?.value || '—' }}</span>
          </div>
          <div class="audit-field">
            <span class="audit-label">Created on</span>
            <span class="audit-value">{{ (serviceConfigForm.get('creationDateTime')?.value | date: 'medium') || '—' }}</span>
          </div>
          <div class="audit-field">
            <span class="audit-label">Last updated on</span>
            <span class="audit-value">{{ (serviceConfigForm.get('lastUpdateDateTime')?.value | date: 'medium') || '—' }}</span>
          </div>
          <div class="audit-field">
            <span class="audit-label">Last updated by</span>
            <span class="audit-value">{{ serviceConfigForm.get('lastUpdatedby')?.value || '—' }}</span>
          </div>
        </div>
      </div>

      @if (responseError && responseError.errorType === 'patchServiceConfig') {
      <nx-message context="error">
        <span class="nx-font-weight-bold">{{ responseError.error }}</span><br />
        {{ responseError.details }}
      </nx-message>
      }
      @if (permissionService.can_write_service_config$ | async) {
      <button nxButton="primary small" type="button" [class.has-spinner]="isServiceConfigUpdating"
        [disabled]="!serviceConfigForm.valid" (click)="updateServiceConfig(addEmailDistributionInput)">
        @if (isServiceConfigUpdating) {
        <nx-spinner size="medium"></nx-spinner>
        }
        Update data mapping
      </button>
      }
    </form>
    }

    @if (responseError && responseError.errorType === 'loadServiceConfig') {
    <nx-message context="error">
      <span class="nx-font-weight-bold">{{ responseError.error }}</span><br />
      {{ responseError.details }}
    </nx-message>
    }

    @if (isServiceConfigLoading) {
    <nx-spinner size="large"></nx-spinner>
    }
  </div>
</div>